import { Dialog } from '@progress/kendo-react-dialogs';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import propTypes from 'prop-types';
import * as r from 'constants/routes';
import { useAppSelector } from '../../../../redux/store';

export default function ProduitsAssignesModal(props) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const token = useAppSelector(state => state.appState.token);

  return (
    <Dialog
      closeIcon={props.closeIcon === undefined ? true : props.closeIcon}
      width={'770px'}
      minWidth={400}
      height={'800px'}
      title="Information"
      onClose={props.toggle}
    >
      {!props.global && (
        <div className='inline' style={{ marginBottom: '5px' }}>
          <div></div>
          <div className="me-auto">
            {props.selectedRow !== undefined && (
              <Button className="blueButton" onClick={() => setDeleteModalVisible(true)}>
                Retirer le produit
              </Button>
            )}
          </div>
        </div>
      )}

      <TabStrip
        animation={false}
        onSelect={(e) => setSelectedTab(e.selected)}
        selected={selectedTab}
      >
        <TabStripTab title="Description">
          <div style={{ marginTop: '5px' }}>
            <iframe
              style={{ width: '700px', height: '600px' }}
              title="information"
              src={`${process.env.REACT_APP_API_URL}${r.CARACT_WEB}?ref=${props.selectedRow.prod_num}&readonly=oui&mode=P&callFrom=WinDevMobile&x-authorization=${token.split(' ')[1]}`}
            />
          </div>
          {deleteModalVisible && (
            <ConfirmationModal
              text={`Retirer le produit ?`}
              onClose={() => {
                setDeleteModalVisible(false);
              }}
              onConfirm={() => {
                setDeleteModalVisible(false);
                props.remove();
                props.toggle();
              }} />
          )}
        </TabStripTab>
      </TabStrip>
    </Dialog>
  );
}

ProduitsAssignesModal.propTypes = {
  selectedRow: PropTypes.shape({
    prod_num: PropTypes.any,
  }),
  toggle: PropTypes.func,
  global: propTypes.bool,
  remove: PropTypes.any,
  closeIcon: PropTypes.any
};
